// src/constants/categoryColors.js
export const CATEGORY_COLORS = {
  Perfect: '#388E3C',
  Good: '#689F38',
  Normal: '#D84315',
  default: '#757575'
};
export const CATEGORY_HARD_COLORS = {
  Perfect: '#4CAF50',
  Good: '#8BC34A',
  Normal: '#FF5722',
  default: '#E0E0E0'
};
